import React from 'react';
import { Icon } from '@bucketplace/design-system/bds';

import { decorateComponent } from '../../documentComponents';
import { getDisallowedAncestors } from '../../utils';
import { ProductListInspector } from './Inspector';
import { ProductList } from './ProductList';

export default decorateComponent(ProductList, 'block', {
  id: 'productList',
  label: '상품리스트',
  defaultProps: {
    type: 1,
    badgeType: 'none',
    products: [],
    useBuyButton: false,
    selectionType: 'MANUAL',
    rankingFilterType: 'CATEGORY',
    title: '',
    subtitle: '',
  },
  allowedChildren: [],
  disallowedAncestors: getDisallowedAncestors(['grid']),
  renderIcon: () => <Icon size={18} name="present_outline" />,
  renderInspector: ProductListInspector,
});
